import parse from 'html-react-parser';

import { Button } from '@/components/core/Button';
import { Dialog, DialogContent, DialogFooter, DialogHeader } from '@/components/core/Dialog';
import { useTranslation } from '@/hooks/useTranslation';

const ReloadItemDialog = ({message, open,  handleReloadItemDialogClose}: {message: string, open?: boolean, handleReloadItemDialogClose: any}) => {
    const {t} = useTranslation();
    return (
        <Dialog open={open}>
            <DialogContent
                variant="small"
                onPointerDownOutside={e => e.preventDefault()}
                onInteractOutside={e => e.preventDefault()}
                onOpenAutoFocus={e => e.preventDefault()}>
                <DialogHeader>{t('ITEM.UPDATED.HEADER')}</DialogHeader>
                <div className='tw-p-4'>{parse(message)}</div>
                <DialogFooter>
                    <Button
                        type="button"
                        variant="default"
                        onClick={()=> handleReloadItemDialogClose()}
                    >
                        {t('OK')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

ReloadItemDialog.displayName = 'RelodItemDialog';

export { ReloadItemDialog };
